import * as SerializerLib from "jsonapi-serializer";

import { serializeError } from "../base.serializer";

const JSONAPISerializer = SerializerLib.Serializer;

const opts = {
  attributes: ["reset_password_token", "password", "password_confirmation"]
};

export const serialize = (data) => {
  try {
    const Serializer = new JSONAPISerializer("users", opts);
    return Serializer.serialize(data);
  } catch (err) {
    return serializeError(err);
  }
};
